import { SlideHeader } from 'components/Shared';
import { useStackableBreadcrumbs } from 'components/Shared/StackedContent/StackableContentContext';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ProductJourneyPages } from '../pages';
import styled from 'styled-components';
import FlexBox from 'components/Shared/Container/FlexBox';
import { BackgroundContainer, HeaderTextContainer, Location, OutputComponent, Title, TotalValue, } from './SiteOverviewSlideContent';
import Icon from 'components/Shared/Icon/Icon';
import BatchTracing from 'components/Shared/BatchTracingContainer/BatchTracing';
import Marker from 'components/Shared/VerifiedPayments/Marker';
import { HeaderContainer } from './Header';
const ScrollContainer = styled.div `
  z-index: 1;
  position: relative;
  height: 100%;
  overflow: auto;
  /* Workaround to fix parents container min-height requirement which overflows the container and hides part of the scrollbar */
  padding-bottom: 30px;

  ${({ isMobile }) => isMobile &&
    `
    min-height: 200px;
    height: calc(100vh - 32px);
  `}
`;
const StyledPaymentsMarker = styled(Marker) `
  margin: 8px 8px 0 4px;
`;
const TracingContainer = styled.div `
  padding: 0 16px 16px;
`;
const MobileSiteBatchDetailsSlide = ({ activeStepActivity, selectedRawMaterial, hasOtherIngredients, isSelectedActivityTraceable, isSelectedStepTraceable, site, }) => {
    var _a, _b;
    const breadcrumbs = useStackableBreadcrumbs();
    const isMobile = true;
    const { t } = useTranslation();
    const scrollRef = useRef();
    const activity = activeStepActivity.activity;
    return (React.createElement(React.Fragment, null,
        React.createElement(SlideHeader, { mobile: true, breadcrumbs: breadcrumbs, labelBackLink: t('back-to-location'), backToStartCrumb: { type: ProductJourneyPages.PRODUCT_JOURNEY } }),
        React.createElement(ScrollContainer, { ref: scrollRef, isMobile: isMobile },
            React.createElement(BackgroundContainer, { m: 2 },
                React.createElement(HeaderContainer, null,
                    React.createElement(StyledPaymentsMarker, { active: true }),
                    React.createElement(HeaderTextContainer, { hasMedia: false },
                        React.createElement(FlexBox, { gap: 1, pt: 1 },
                            React.createElement(Title, null, site.title)),
                        React.createElement(Location, null, site.locationName))),
                React.createElement(FlexBox, { gap: 1 },
                    activity.component && (React.createElement(OutputComponent, null, activity.component.title)),
                    ((_a = site.workersSummary) === null || _a === void 0 ? void 0 : _a.workerAmount) > 0 && (React.createElement(TotalValue, { gap: 1 },
                        React.createElement(Icon, { name: "group", size: "large" }),
                        ((_b = site.workersSummary) === null || _b === void 0 ? void 0 : _b.workerAmount) || 0,
                        ' ',
                        t('tracing.total-farmers'))))),
            React.createElement(TracingContainer, null,
                React.createElement(BatchTracing, { hasOtherIngredients: hasOtherIngredients, rawMaterial: selectedRawMaterial, batchTracingActive: true, notTraceableActivity: !isSelectedActivityTraceable, notTraceableStep: !isSelectedStepTraceable, chainStepActivity: activeStepActivity, hideLocationPin: true, selectedSiteId: site.id })))));
};
export default MobileSiteBatchDetailsSlide;
